import { z } from 'zod';
import { SKILL_LIMITS } from '../skills/limits.ts';

const at = z.string();

export const ConsoleSkillStatusSchema = z.enum(['draft', 'listed', 'withdrawn']);
export type ConsoleSkillStatus = z.infer<typeof ConsoleSkillStatusSchema>;

export const ConsoleSkillSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  status: ConsoleSkillStatusSchema,
  always_on: z.boolean(),
  version: z.number().int().positive(),
  invocation_count: z.number().int().nonnegative(),
  created_at: at,
  updated_at: at,
});
export type ConsoleSkill = z.infer<typeof ConsoleSkillSchema>;

export const ConsoleSkillsSchema = z.object({ skills: z.array(ConsoleSkillSchema) });
export type ConsoleSkills = z.infer<typeof ConsoleSkillsSchema>;

export const ConsoleSkillFileSchema = z.object({
  path: z.string().min(1).max(SKILL_LIMITS.maxPathChars),
  content: z.string(),
});
export type ConsoleSkillFile = z.infer<typeof ConsoleSkillFileSchema>;

export const ConsoleSkillDetailSchema = ConsoleSkillSchema.extend({
  instructions: z.string(),
  files: z.array(ConsoleSkillFileSchema),
  versions: z.array(
    z.object({
      version: z.number().int().positive(),
      description: z.string(),
      created_at: at,
    }),
  ),
});
export type ConsoleSkillDetail = z.infer<typeof ConsoleSkillDetailSchema>;

/** A skill folder: SKILL.md and any other text files, by path inside the folder. */
export const ConsoleSkillUploadRequestSchema = z.strictObject({
  files: z.array(ConsoleSkillFileSchema).min(1).max(SKILL_LIMITS.maxFiles),
});
export type ConsoleSkillUploadRequest = z.infer<typeof ConsoleSkillUploadRequestSchema>;

export const ConsoleSkillUpdateRequestSchema = z.strictObject({
  status: ConsoleSkillStatusSchema.optional(),
  always_on: z.boolean().optional(),
});
export type ConsoleSkillUpdateRequest = z.infer<typeof ConsoleSkillUpdateRequestSchema>;
